import { InstallmentOption } from "@/pages/checkout/types";
import { moneyFormat } from "./formatUtil";

/**
 * AEA-55 — A tabela de juros do parcelamento passou a viver SÓ na API
 * (GET /payment/installments). O front apenas renderiza a opção recebida.
 */
export const formatInstallmentLabel = (option: InstallmentOption): string =>
  `${option.installment}x de ${moneyFormat(
    option.installmentValueCents / 100
  )}`;

const onlyDigits = (value: string): string => value.replace(/\D/g, "");

/**
 * AEA-55 / AD-10 — PAN de 14 a 19 dígitos (alinhado ao contrato da Rede).
 * A restrição de 16 fixos era nossa e bloqueava Diners (14), Amex (15) e JCB (19).
 */
export const isValidCardNumberLength = (value: string): boolean => {
  const length = onlyDigits(value).length;
  return length >= 14 && length <= 19;
};

/**
 * AEA-55 / AD-10 — CVV de 3 ou 4 dígitos (Amex usa 4).
 */
export const isValidSecurityCodeLength = (value: string): boolean => {
  const length = onlyDigits(value).length;
  return length === 3 || length === 4;
};

/**
 * AEA-55 / AD-10 — Formata a entrada do PAN: só dígitos, no máximo 19, agrupados de
 * 4 em 4 para leitura. Substitui a máscara fixa de 16 que travava a digitação.
 */
export const formatCardNumberInput = (raw: string): string =>
  onlyDigits(raw)
    .slice(0, 19)
    .replace(/(.{4})/g, "$1 ")
    .trim();

/**
 * AEA-55 / AD-10 — Sanitiza o CVV: só dígitos, no máximo 4.
 */
export const sanitizeSecurityCode = (raw: string): string =>
  onlyDigits(raw).slice(0, 4);
